import { useSyncExternalStore } from "react";

function subscribe(query: string): (cb: () => void) => () => void {
  return (cb) => {
    const mql = window.matchMedia(query);
    mql.addEventListener("change", cb);
    return () => mql.removeEventListener("change", cb);
  };
}

function getSnapshot(query: string): () => boolean {
  return () => window.matchMedia(query).matches;
}

function getServerSnapshot(): boolean {
  return false;
}

/**
 * Reactive hook that tracks a CSS media query.
 *
 * @param query - A valid media query string, e.g. `"(min-width: 1024px)"`
 * @returns `true` when the query matches, `false` otherwise
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(subscribe(query), getSnapshot(query), () => getServerSnapshot());
}

// Tailwind default breakpoints
const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280
} as const;

/** Matches screens narrower than `sm` (< 640px). */
export function useIsMobile(): boolean {
  return useMediaQuery(`(max-width: ${BREAKPOINTS.sm - 1}px)`);
}

/** Matches screens narrower than `lg` (< 1024px). */
export function useIsMobileOrTablet(): boolean {
  return useMediaQuery(`(max-width: ${BREAKPOINTS.lg - 1}px)`);
}

/** Matches screens at `lg` and above (>= 1024px). */
export function useIsDesktop(): boolean {
  return useMediaQuery(`(min-width: ${BREAKPOINTS.lg}px)`);
}
